import { useEffect, useState } from "react";
import { Box, Button, Grid, Card, CardContent, TextField, Alert } from "@mui/material";
import axios from 'axios';
import { URL, getRequestAccess } from "../helper";

const stylesInput = {
  sx:{
    backgroundColor: 'white',
    color: 'white',
    width: '100%',
    padding: 0,
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#8BAB89"
      }
    }
  },
  inputProps:{
    sx: {
      padding: '3px 10px',
      fontFamily: 'KIT65P',
      fontSize: '1.5rem',
    },
  }  
}

const init = {
  validbegin: '',
  validend: '',
  imgbase64: '',
  videobase64: '',
  title: '',
}

function FormItem({ getListSlide, imagesList, isCreate, itemEdit, setIsCreate }){
  const [data, setData] = useState({ ...init });
  const [isError, setIsError] = useState(false);
  const [textError, setTextError] = useState('');

  const [isSuccess, setIsSuccess] = useState(false);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (isCreate) {
      setData({ ...init });
    } else {
      setData({
        ...itemEdit
      })
    }
  }, [isCreate, itemEdit]);

  const onSave = () => {
    if (data.validbegin && data.validend && (data.imgbase64 || data.imgurl || data.videobase64 || data.videourl)) {
      if (data.validbegin >= data.validend) {
        setTextError('วันสิ้นสุด ต้องมากกว่า วันเริ่มต้น');
        setIsError(true);
      } else {
        setIsError(false);

        const maxValue = Math.max(...imagesList.map((m) => (m.slot || 0)));
        const _data = {
          photoid: isCreate ? '' : data.photoid,
          titleth: data.title || data.titleth,
          titleen: data.title || data.titleen,
          slot: isCreate ? maxValue + 1 : data.slot,
          allbranch: isCreate ? true : data.allbranch,
          active: isCreate ? true : data.active,
          validbegin: data.validbegin.replace('T', ' ') + ':00',
          validend: data.validend.replace('T', ' ') + ':00',
          branches: isCreate ? [] : data.branches,

          imgbase64: data.imgbase64 ? data.imgbase64.split(',')[1] : '',
          videobase64: data.videobase64 ? data.videobase64.split(',')[1] : '',

          imgurl: '',
          videourl: '',

          requestaccess: getRequestAccess(),
        }
  
        axios.post(isCreate ? URL.add : URL.edit, _data).then((res) => {
          if (res?.status === 200) {
            if (res?.data?.result === "complete") {
              getListSlide();
              onCancel();

              setIsSuccess(true);
              setCounter(2);
            } else {
              setTextError('เกิดข้อผิดพลาด บันทึกไม่สำเร็จ');
              setIsError(true);
            }
          } else {
            setTextError('เกิดข้อผิดพลาด บันทึกไม่สำเร็จ');
            setIsError(true);
          }
        }).catch(error => {
          setTextError('เกิดข้อผิดพลาด บันทึกไม่สำเร็จ');
          setIsError(true);
        });
      }
    } else {
      setTextError('กรุณากรอกข้อมูลให้ครบถ้วน');
      setIsError(true);
    }
  }

  const onCancel = () => {
    setIsCreate(true);
    setIsError(false);
    setTextError('');
    setData({ ...init });
  }

  const onClickUploadFile = async (e) => {
    if (!e.target.files.length) return;

    let _file = e.target.files[0];
    console.log(_file);
    if (_file.size > 5242880) {
      setData({
        ...data,
        imgbase64: '',
        title: '',
        type: ''
      })
      setTextError('ขนาดไฟล์ใหญ่เกินไป (5 MB)');
      setIsError(true);
    } else if (_file.type.includes('image/')) {
      setIsError(false);
      setData({
        ...data,
        imgbase64: await toBase64(_file),
        imgurl: '',
        videobase64: '',
        videourl: '',
        title: _file.name,
        mediatype: 'image'
      })
    } else if (_file.type.includes('video/')) {
      setIsError(false);
      setData({
        ...data,
        imgbase64: '',
        imgurl: '',
        videobase64: await toBase64(_file),
        videourl: '',
        title: _file.name,
        mediatype: 'video'
      })
    } else {
      setData({
        ...data,
        imgbase64: '',
        title: '',
        type: ''
      })
      setTextError('ประเภทของไฟล์ไม่ถูกต้อง (ต้องเป็นรูปภาพ / VDO)');
      setIsError(true);
    }
  }

  const handleClick = event => {
    const { target = {} } = event || {};
    target.value = "";
  };

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => {
        setCounter(counter - 1);
      }, 1000)
    } else {
      setIsSuccess(false);
    }
  }, [counter])

  return (
    <Card>
      <CardContent>
        <h5 style={{ textAlign: 'center', marginBottom: 10 }}>เพิ่มรูปภาพ / VDO</h5>
        <label htmlFor="file">
          {data.imgbase64 ? (
            <img src={data.imgbase64} style={{ width: '100%', height: 'auto' }} />
          ) : data.videobase64 ? (
            <video autoPlay muted loop
              style={{ width: '100%', maxHeight: 250 }}
              src={data.videobase64}
            >
            </video>
          ) : data.imgurl ? (
            <img src={data.imgurl} style={{ width: '100%', height: 'auto' }} />
          ) : data.videourl ? (
            <video autoPlay muted loop
              style={{ width: '100%', maxHeight: 250 }}
              src={data.videourl}
            >
            </video>
          ) : (
            <Box sx={{
              width: '100%',
              minHeight: 300,
              background: '#F1F1F1',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}>
              <img src="/images/more.png" style={{ width: 60, height: 'auto', textAlign: 'center' }} />
            </Box>
          )}
          <input
            type="file"
            name="file"
            id="file"
            style={{ display: 'none' }}
            onChange={(e) => onClickUploadFile(e)}
            onClick={(e) => handleClick(e)}
            // accept={"image/png, image/jpeg"}    
          />
        </label>

        <Box mt={2}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <p>เริ่มต้น</p>
            </Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                {...stylesInput}
                type="datetime-local"
                value={data.validbegin}
                onChange={(e) => setData({
                  ...data,
                  validbegin: e.target.value
                })}
              />
            </Grid>
          </Grid>
        </Box>

        <Box mt={2}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <p>สิ้นสุด</p>
            </Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                {...stylesInput}
                type="datetime-local"
                value={data.validend}
                onChange={(e) => setData({
                  ...data,
                  validend: e.target.value
                })}
              />
            </Grid>
          </Grid>
        </Box>

        {isError && (
          <Box mt={1.5}>
            <Alert severity="error" sx={{ alignItems: 'center', fontFamily: 'KIT65P', fontSize: '1.2rem' }}>{textError}</Alert>
          </Box>
        )}

        {isSuccess && (
          <Box mt={1.5}>
            <Alert severity="success" sx={{ alignItems: 'center', fontFamily: 'KIT65P', fontSize: '1.2rem' }}>บันทึกสำเร็จ</Alert>
          </Box>
        )}

        <Box sx={{ display: 'flex', mt: 2.5, justifyContent: 'center' }}>
          <Button onClick={onSave} style={{ 
            color: 'white',
            fontFamily: 'KIT65P',
            fontSize: '1.5rem',
            padding: '2px 10px',
            width: 100,
            background: 'rgba(95, 150, 108, 0.7)',
            borderRadius: '16px',
            marginRight: 10
          }}>บันทึก</Button>

          <Button onClick={onCancel} style={{ 
            color: 'white',
            fontFamily: 'KIT65P',
            fontSize: '1.5rem',
            padding: '2px 10px',
            width: 100,
            background: 'rgba(255, 0, 0, 0.7)',
            borderRadius: '16px'
          }}
          >ยกเลิก</Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default FormItem;
